import React, { useEffect, useState } from "react";
import axios from "../../../api/axios.js";
import {
  convertIntoSelect2Options,
  getFetchOptions,
} from "../../../js/utility.js";
import Breadcrumb from "../../utils/Breadcrumb.jsx";
import Select from "react-select";

const AddCulturalPlace = () => {
  const [formData, setFormData] = useState({});
  const [provOptions, setProvOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);

  const [modalShow, setModalShow] = useState(false);
  const [modalData, setModalData] = useState({});
  const [modalFilterResults, setModalFilterResults] = useState([]);
  const [importImageLink, setImportImageLink] = useState("");

  const breadcrumb = {
    current_section: "Luoghi della Cultura",
    sections: [
      { name: "Home", route_name: null, params: [] },
      { name: "Luoghi", route_name: null, params: [] },
      { name: "Nuovo", route_name: null, params: [] },
    ],
  };

  useEffect(() => {
    const fetchProvs = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseURL}/provincie`,
          fetchOptions
        );
        const result = await response.json();
        result.provincie.sort((a, b) => a.nome.localeCompare(b.nome));
        setProvOptions(
          convertIntoSelect2Options(result.provincie, "id", "nome")
        );
      } catch (error) {
        console.error(error);
      }
    };
    fetchProvs();
  }, []);

  const handleNameChange = (e) => {
    setFormData((prevData) => ({ ...prevData, nome: e.target.value }));
  };

  // const handleCodeChange = (e) => {
  //   setFormData((prevData) => ({ ...prevData, codice: e.target.value }));
  // };

  const handleProvinceChange = (e) => {
    setFormData((prevData) => ({ ...prevData, idprovincia: e?.value }));

    const fetchCities = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/app/getTowns?idprov=${e?.value}`,
          fetchOptions
        );
        const result = await response.json();

        setCityOptions(convertIntoSelect2Options(result, "id", "nome"));
      } catch (error) {
        console.error(error);
      }
    };
    fetchCities();
  };

  const handleCityChange = (e) => {
    setFormData((prevData) => ({ ...prevData, idcomune: e?.value }));
  };

  const handleLongChange = (e) => {
    setFormData((prevData) => ({ ...prevData, longitude: e.target.value }));
  };

  const handleLatChange = (e) => {
    setFormData((prevData) => ({ ...prevData, latitude: e.target.value }));
  };

  const handleAddressChange = (e) => {
    setFormData((prevData) => ({ ...prevData, indirizzo: e.target.value }));
  };

  const handleDescriptionChange = (e) => {
    setFormData((prevData) => ({ ...prevData, descrizione: e.target.value }));
  };

  const handleSave = () => {
    if (!formData.nome) {
      alert("Il nome del luogo è obbligatorio.");
      return;
    }
    if (!formData.idprovincia) {
      alert("La provincia è obbligatoria.");
      return;
    }
    if (!formData.idcomune) {
      alert("Il comune è obbligatorio.");
      return;
    }
    if (!formData.longitude) {
      alert("La longitudine è obbligatoria.");
      return;
    }
    if (!formData.latitude) {
      alert("La latitudine è obbligatoria.");
      return;
    }
    if (!formData.indirizzo) {
      alert("L'indirizzo è obbligatorio.");
      return;
    }

    if (!formData.codice) {
      formData.codice = formData.nome.replace(/\s+/g, "_").slice(0, 20);
    }

    const fetchOptions = getFetchOptions(
      "application/x-www-form-urlencoded",
      formData,
      "POST"
    );

    fetch(`${axios.defaults.baseURL}/ldc/ldcinsert`, fetchOptions)
      .then(async (response) => {
        if (response.status !== 200) {
          console.error("Failed to save cultural place:", response);
          alert("Errore durante il salvataggio del luogo della cultura");
          throw new Error("Failed to save cultural place");
        }

        const responseData = await response.json();
        console.log("Cultural place saved successfully:", responseData);
        if (importImageLink) {
          const fetchOptions = getFetchOptions(
            "application/json",
            {
              ldcId: responseData.return.ldc.id,
              importLink: importImageLink,
            },
            "PUT"
          );

          await fetch(
            `${axios.defaults.baseBFFUrl}/fe/updateImportImageLink`,
            fetchOptions
          );
        }
      })
      .finally(() => {
        window.location.href = "/culturalPlaces";
      })
      .catch((error) => {
        console.error("Error saving cultural place:", error);
      });
  };

  // Modal functions
  const handleModalProvinceChange = (e) => {
    setModalData((prevData) => ({
      ...prevData,
      provincia: e?.label,
      idprovincia: e?.value,
    }));
    const fetchCities = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/app/getTowns?idprov=${e?.value}`,
          fetchOptions
        );
        const result = await response.json();
        setCityOptions(convertIntoSelect2Options(result, "id", "nome"));
      } catch (error) {
        console.error(error);
      }
    };
    fetchCities();
  };
  const handleModalCityChange = (e) => {
    setModalData((prevData) => ({
      ...prevData,
      comune: e?.label,
      idcomune: e?.value,
    }));
  };
  const handleFilterModalData = async () => {
    const QUANTITY_FOR_REQUEST = 20;

    if (modalData.provincia && !modalData.comune) {
      alert(
        "Per la ricerca per provincia è necessario selezionare anche un comune."
      );
      return;
    }

    const fetchOptions = getFetchOptions(
      "application/x-www-form-urlencoded",
      [],
      "GET"
    );

    await fetch(
      `${axios.defaults.baseBFFUrl}/fe/getOpenDataLDC?testo=${
        modalData.testo ?? ""
      }&provincia=${modalData.provincia ?? ""}&comune=${
        modalData.comune ?? ""
      }&quantita=${QUANTITY_FOR_REQUEST}`,
      fetchOptions
    )
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data.length > 0) {
          setModalFilterResults(data);
        } else {
          alert("Nessun risultato trovato");
          setModalFilterResults([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  const calculateLatLon = (address, comune, provincia) => {
    const fetchOptions = getFetchOptions(
      "application/x-www-form-urlencoded",
      [],
      "GET"
    );
    fetch(
      `${axios.defaults.baseBFFUrl}/fe/getLatLon?indirizzo=${address}&comune=${comune}&provincia=${provincia}`,
      fetchOptions
    )
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          setFormData((prevData) => ({
            ...prevData,
            latitude: data.latitudine,
            longitude: data.longitudine,
          }));
        } else {
          alert("Nessun risultato trovato");
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  return (
    <div className="container-fluid">
      {/* Breadcrumb */}
      <Breadcrumb breadcrumb={breadcrumb} />
      <a href="/culturalPlaces">
        <button className="btn btn-primary mb-4">
          <i className="bi bi-arrow-left"></i> Torna alla lista ldc
        </button>
      </a>
      <br />
      <label className="mb-4">
        <b>(*) Campo obbligatorio</b>
      </label>

      {/* Cultural Place Details */}
      <div className="card custom-card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <span>Dati generali</span>
          <button
            className="btn btn-primary"
            onClick={() => setModalShow(true)}
          >
            Importa da Opendata
          </button>
        </div>
        <div className="card-body">
          {/* Modal */}
          {modalShow && (
            <div className="modal-backdrop-custom">
              <div className="modal show d-block" tabIndex="-1" role="dialog">
                <div
                  className="modal-dialog modal-dialog-centered modal-xl"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">
                        Importa da Opendata{" "}
                        <span className="text-danger fs-11">
                          20 luoghi caricati per volta, inserire testo per
                          ricerca piu` specifica (attendere qualche secondo per
                          il caricamento)
                        </span>
                      </h5>
                      <button
                        type="button"
                        className="btn btn-close"
                        onClick={() => setModalShow(false)}
                      />
                    </div>
                    <div className="modal-body">
                      <div className="row mb-3">
                        <div className="col">
                          <label htmlFor="filterName">Testo </label>
                          <input
                            id="filterName"
                            name="filterName"
                            className="form-control"
                            placeholder="Inserisci nome..."
                            onChange={(e) =>
                              setModalData((prevData) => ({
                                ...prevData,
                                testo: e.target.value,
                              }))
                            }
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="filterProvince">Provincia</label>
                          <Select
                            options={provOptions}
                            id="filterProvince"
                            name="filterProvince"
                            placeholder="Scegli provincia..."
                            isSearchable
                            isClearable
                            onChange={handleModalProvinceChange}
                          />
                        </div>
                        <div className="col">
                          <label htmlFor="filterCity">Comune</label>
                          <Select
                            options={cityOptions}
                            id="filterCity"
                            name="filterCity"
                            placeholder="Scegli comune..."
                            isSearchable
                            isClearable
                            onChange={handleModalCityChange}
                          />
                        </div>
                        <div className="col d-flex align-items-end justify-content-end me-2">
                          <button
                            className="btn btn-primary mt-4"
                            onClick={handleFilterModalData}
                          >
                            <i className="bi bi-search"></i> Cerca
                          </button>
                        </div>
                      </div>
                      <div
                        className="table-responsive"
                        style={{ maxHeight: "300px", overflowY: "auto" }}
                      >
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th>Immagine</th>
                              <th>Nome</th>
                              <th>Descrizione</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {modalFilterResults?.map((result) => (
                              <tr key={result.id}>
                                <td>
                                  <img
                                    src={result.immagine}
                                    alt={result.nome}
                                    className="img-fluid"
                                    style={{ width: "100px" }}
                                  />
                                </td>
                                <td>{result.nome}</td>
                                <td title={result.descrizione}>
                                  {result.descrizione?.length > 100
                                    ? `${result.descrizione.slice(0, 100)}...`
                                    : result.descrizione}
                                </td>
                                <td>
                                  <button
                                    className="btn btn-primary"
                                    onClick={async () => {
                                      let openDataProvinceId = provOptions.find(
                                        (option) =>
                                          option.label === result.provincia
                                      )?.value;

                                      let response = await fetch(
                                        `${axios.defaults.baseBFFUrl}/app/getTowns?idprov=${openDataProvinceId}`,
                                        getFetchOptions(
                                          "application/x-www-form-urlencoded",
                                          [],
                                          "GET"
                                        )
                                      );
                                      let towns = await response.json();

                                      const convertedCityOptions =
                                        convertIntoSelect2Options(
                                          towns,
                                          "id",
                                          "nome"
                                        );
                                      await setCityOptions(
                                        convertedCityOptions
                                      );

                                      let openDataTownId =
                                        convertedCityOptions.find(
                                          (option) =>
                                            option.label === result.comune
                                        )?.value;

                                      setFormData((prevData) => ({
                                        ...prevData,
                                        nome: result.nome,
                                        idprovincia:
                                          openDataProvinceId ||
                                          modalData.idprovincia,
                                        idcomune:
                                          openDataTownId || modalData.idcomune,
                                        indirizzo: result.indirizzo,
                                        codice: result.nome
                                          .replace(/\s+/g, "_")
                                          .slice(0, 20),
                                        descrizione: result.descrizione.slice(
                                          0,
                                          100
                                        ),
                                      }));

                                      calculateLatLon(
                                        result.indirizzo,
                                        modalData.comune,
                                        modalData.provincia
                                      );

                                      setImportImageLink(result.immagine);
                                      setModalShow(false);
                                    }}
                                  >
                                    Seleziona
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setModalShow(false)}
                      >
                        Chiudi
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="row mb-3">
            <div className="col">
              <label htmlFor="nome">
                Nome del luogo <b>*</b>
              </label>
              <input
                id="nome"
                name="nome"
                className="form-control"
                value={formData.nome}
                onChange={handleNameChange}
              />
            </div>
            {/* <div className="col">
              <label htmlFor="codice">Codice Luogo</label>
              <input
                id="codice"
                name="codice"
                className="form-control"
                value={formData.codice}
                onChange={handleCodeChange}
              />
            </div> */}
          </div>

          <div className="row mb-3">
            <div className="col">
              <label htmlFor="province">
                Provincia <b>*</b>
              </label>
              <Select
                options={provOptions}
                id="province"
                name="province"
                value={provOptions.filter(function (option) {
                  return option.value === Number(formData.idprovincia);
                })}
                onChange={handleProvinceChange}
                classNames={"form-control"}
                placeholder="Scegli provincia..."
                isSearchable
                isClearable
              />
            </div>
            <div className="col">
              <label htmlFor="city">
                Comune <b>*</b>
              </label>
              <Select
                options={cityOptions}
                id="city"
                name="city"
                value={cityOptions?.filter(function (option) {
                  return option.value === Number(formData.idcomune);
                })}
                onChange={handleCityChange}
                classNames={"form-control"}
                placeholder="Scegli comune..."
                isSearchable
                isClearable
              />
            </div>
          </div>

          {/* Longitude, Latitude, and Address */}
          <div className="row mb-3">
            <div className="col-4 col-lg-2">
              <label htmlFor="longitudine">
                Longitudine <b>*</b>
              </label>
              <input
                id="longitudine"
                name="longitudine"
                className="form-control"
                value={formData.longitude}
                onChange={handleLongChange}
              />
            </div>
            <div className="col-4 col-lg-2">
              <label htmlFor="latitudine">
                Latitudine <b>*</b>
              </label>
              <input
                id="latitudine"
                name="latitudine"
                label="Latitudine"
                className="form-control"
                value={formData.latitude}
                onChange={handleLatChange}
              />
            </div>
            <div className="col-4 col-lg-8">
              <label htmlFor="indirizzo">
                Indirizzo <b>*</b>
              </label>
              <input
                id="indirizzo"
                name="indirizzo"
                label="Indirizzo"
                className="form-control"
                value={formData.indirizzo}
                onChange={handleAddressChange}
              />
            </div>
          </div>

          {/* Short Description */}
          <div className="row mb-3">
            <div className="col-12">
              <label htmlFor="smallDesc">Breve descrizione</label>
              <textarea
                id="descrizione"
                name="descrizione"
                className="form-control w-100"
                value={formData.descrizione || ""}
                onChange={handleDescriptionChange}
              >
                {formData.descrizione}
              </textarea>
            </div>
          </div>

          {/* Save Button */}
          <div className="saveButtonContainer">
            <button
              id="savePlaceBtn"
              name="savePlaceBtn"
              className="btn btn-success saveButton"
              type="button"
              onClick={handleSave}
            >
              &nbsp;Salva
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddCulturalPlace;
